export default {"src":"/_next/static/media/USA.ed21322f.svg","height":401,"width":320,"blurWidth":0,"blurHeight":0};